<template xmlns:v-swiper="http://www.w3.org/1999/xhtml">
  <div>
    <div class="main main-custom">
      <div class="primarylists">
        <ul class="container">
          <li>
            <div class="titles clear">
              <div class="title l">受講者ご利用ガイド</div>
            </div>
            <p style="text-align: right">
              Ver1.00&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2021.04.01
            </p>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
             <div class="secondlists">
        <ul class="container padding-top">
          <li>
            <div class="titles">
              <div class="title l">1.表示言語の切り替え</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_1.png" />
            <p>
              画面上部のメインメニューバーにある国旗アイコンをクリックし、プルダウンメニューにて表示言語を切り替えることができます。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">2.ログイン</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_2.png" />
            <p>
              ①.画面上部のメインメニューバーにあるLoginアイコンをクリックし、ログイン情報入力ポップアップ画面が表示されます。
            </p>
            <p>
              ②.ログイン情報入力ポップアップ画面にあるアカウント名とパスワード情報を入力します。
            </p>
            <p>③.「ログイン」ボタンを押下し、ログイン処理を行います。</p>
            <p>
              ※初期パスワードのままでお使いの場合、ログイン後にパスワード変更画面に強制遷移し、初期パスワード変更を促す警告メッセージが表示されます。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">3.ログアウト</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_3.png" />
            <p>
              ログインしている状態で、画面上部のメインメニューバーにあるログアウトアイコンをクリックすると、システムからログアウトすることができます。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">4.コース検索</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_4.png" />
            <p>
              画面上部のメインメニューバーにある検索入力ボックスに検索キーワードを入力し、「検索」ボタンをクリックすると、検索キーワードと関連したコースが検索結果として表示されます。
            </p>
            <p>検索結果のイメージは以下の通りとなります。</p>
            <img src="../../../static\images\ja\manual_ja_5.png" />
            <p>
              参照したいコースをクリックすると、コース詳細画面に遷移していきます。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">5.パスワード変更</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_6.png" />
            <p>
              ①.画面上部のメインメニューバーにあるユーザアイコンをクリックし、ユーザプロファイル管理画面が表示されます。
            </p>
            <p>
              ②.画面左側にあるサイドメニューから「パスワード変更」をクリックし、右側に「パスワード変更」タブが表示されます。
            </p>
            <p>
              ③.「現在のパスワード」、「新しいパスワード」、「新しいパスワード(確認)」を入力してから「変更」ボタンを押下します。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">6.マイコース</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_7.png" />
            <p>
              画面上部のメインメニューバーにある「マイコース」アイコンをクリックすると、マイコース画面に遷移します。
            </p>
            <img src="../../../static\images\ja\manual_ja_8.png" />
            <p>
              マイコース画面では、受講したコースが受講開始日順で表示されます。
            </p>
            <p style="color: red">
              ※メインメニューバーの検索の対象は、マイコースだけではなく、システム全体となっています。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.コース受講</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
          </li>
        </ul>
      </div>
      <div class="thirdlists">
        <ul class="container">
          <li>
            <div class="titles">
              <div class="title l">7.1.コース選択</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_9.png" />
            <p>
              ホーム画面、又はマイコース画面にて学習対象コースを選択し、コース概要画面に遷移します。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.2.コンテンツ閲覧</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_10.png" />
            <p>
              ①.コース概要画面において、「学習開始」ボタンを押下し、コース目次画面に遷移します。
            </p>
            <img src="../../../static\images\ja\manual_ja_11.png" />
            <img src="../../../static\images\ja\manual_ja_12.png" />
            <p>
              ②.コース目次にある節のリンクをクリックし、該当節と紐づいているコンテンツを学習します。
            </p>
            <p>
              ③.「次へ」、又は「前へ」ボタンにてコンテンツを切り替えることができます。
            </p>
            <p style="color: red">
              ※各節の配下にあるコンテンツが全て閲覧されたら、節のマークが緑色状態に変わります。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.3.小テスト</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_13.png" />
            <p>
              ①.小テストのある章節に、小テスト列に小テストマークが表示されます。小テストマーク（赤色状態）をクリックすると、小テスト画面に遷移されます。
            </p>
            <img src="../../../static\images\ja\manual_ja_14.png" />
            <p>②.設問の内容を確認し、選択肢から回答を選択します。</p>
            <p>③.「採点」ボタンを押下し、小テストを提出します。</p>
            <img src="../../../static\images\ja\manual_ja_15.png" />
            <p>
              ④.採点結果は得点率列に表示されます。全問正解となると、小テストマークが緑色状態に変わります。
            </p>
            <p style="color: red">
              ※小テストは、学習進捗、及び学習成績の評価対象ではありません。実施しなくても受講は継続できます。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.4.修了試験</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_16.png" />
            <p>
              ①.目次に沿ってコンテンツを全て学習完了すると、進捗率は60％になります。サブメニューバーにある「修了試験」リンクをクリックすると、修了試験画面が表示されます。
            </p>
            <img src="../../../static\images\ja\manual_ja_17.png" />
            <p>
              ②.「試験開始」ボタンを押下し、修了試験は開始します。「キャンセル」ボタンを押下すると、コース目次画面に戻ります。
            </p>
            <p style="color: red">
              ※修了試験は、何回でも受けられます。最終回の成績で合格・不合格を判定します。
            </p>
            <img src="../../../static\images\ja\manual_ja_18.png" />
            <p>
              ③.「前へ」、又は「次へ」ボタンで試験問題を切替えることができます。「提出」ボタンを押下すると、回答状況確認画面に遷移します。
            </p>
            <img src="../../../static\images\ja\manual_ja_19.png" />
            <p>
              ④.回答状況確認画面で全問を回答したことを確認し、「提出」ボタンを押下し、修了試験の提出確認ダイアログが表示されます。
            </p>
            <p>
              ⑤.「OK」ボタンを押下すると、回答が提出され、修了試験は終了します。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.5.誓約書</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_20.png" />
            <p>
              ①.修了試験は合格すると、進捗率は80％になります。サブメニューバーにある「誓約書」リンクをクリックし、誓約書画面が表示されます。
            </p>
            <img src="../../../static\images\ja\manual_ja_21.png" />
            <p>②.各誓約書画面の同意チェックボックスをチェックを入れます。</p>
            <p>③.「提出」ボタンを押下し、誓約書を提出します。</p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.6.アンケート</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_22.png" />
            <p>
              ①.誓約書は提出すると、進捗率は90％になります。サブメニューバーにある「アンケート」リンクをクリックし、アンケート画面が表示されます。
            </p>
            <img src="../../../static\images\ja\manual_ja_23.png" />
            <p>②.アンケート画面にある全ての設問を回答します。</p>
            <p>③.「提出」ボタンを押下し、アンケートを提出します。</p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.7.修了申請</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_24.png" />
            <p>
              ①.サブメニューバーにある「修了申請」リンクをクリックし、修了申請画面が表示されます。
            </p>
            <p style="color: red">
              ※アンケートを提出しますと、進捗率は99％になり、修了申請画面が自動的に表示されます。
            </p>
            <img src="../../../static\images\ja\manual_ja_25.png" />
            <p>②.コースの進捗状況を確認します。</p>
            <p>
              ③.アンケートまで完了すると、「申請」ボタンが「アクティブ」状態になります。「申請」ボタンを押下すると、本コースは終了します。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.8.不正解問題一覧</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_26.png" />
            <p>
              ①.修了試験の完了後、サブメニューバーの「不正解問題一覧」リンクをクリックし、不正解問題一覧画面が表示されます。
            </p>
            <img src="../../../static\images\ja\manual_ja_27.png" />
            <p>②.全ての不正解問題の正解、解析を確認することができます。</p>
            <p>
              ②.不正解リストから削除：該当問題を不正解問題リストから削除します。
            </p>
            <p>
              ③.不正解リスト出力：全ての不正解問題をEXCELファイルとしてエクスポートします。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.9.成績確認</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_28.png" />
            <p>
              ①.修了試験の完了後、サブメニューバーの「成績分析」リンクをクリックし、成績状況画面が表示されます。
            </p>
            <img src="../../../static\images\ja\manual_ja_29.png" />
            <p>②.修了試験の成績を参照することができます。</p>
            <p>
              ③.「受験履歴」リンクをクリックすると、受講履歴画面に遷移されます。
            </p>
            <img src="../../../static\images\ja\manual_ja_30.png" />
            <p>④.「戻る」ボタンを押下するとと、成績状況画面に戻ります。</p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">7.10.ノート・ノート出力</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_31.png" />
            <p>
              ①.コンテンツ学習画面の左側表示エリアにある「ノート」タブをクリックすると、メモ用の入力エリアが表示されます。該当章節の内容をメモすることができます。
            </p>
            <img src="../../../static\images\ja\manual_ja_32.png" />
            <p>
              ②.サブメニューバーの「ノート出力」リンクをクリックし、各章節のメモを纏めてWORDファイルとしてエクスポートすることができます。
            </p>
          </li>
        </ul>
      </div>
      <div class="secondlists">
        <ul class="container">
          <li>
            <div class="titles">
              <div class="title l">8.学習状況-受講状況</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_33.png" />
            <p>
              ①.画面上部にあるメインメニューバーにある「学習状況」⇒「受講状況」メニューをクリックすると、受講したコースの学習進捗状況を参照するができます。
            </p>
            <p>
              ②.コース名称のマークをクリックすると、該当するコース詳細画面に遷移していきます。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">9.ライブ講義</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_34.png" />
            <p>
              画面上部のメインメニューバーにある「ライブ講義」アイコンをクリックすると、ライブ講義の情報を参照できる。
            </p>
          </li>
          <li>
            <div class="titles">
              <div class="title l">10.進捗確認（※受講管理者権限のみ※）</div>
            </div>
            <div style="border-bottom: 1px solid #1a1a1a"></div>
            <img src="../../../static\images\ja\manual_ja_35.png" />
            <p>
              ①.コース概要画面において、「進捗確認」ボタンを押下し、進捗確認画面に遷移します。
            </p>
            <img src="../../../static\images\ja\manual_ja_36.png" />
            <p>
              ②.検索条件を入力し、「検索」ボタンを押下し、検索結果を確認します。
            </p>
            <p>
              ③.「エクスポート」ボタンを押下し、検索結果をEXCELとしてエクスポートされます。
            </p>
          </li>
        </ul>
      </div>
          </li>
        </ul>
      </div>
     
    </div>
  </div>
</template>

<script>
//课程页轮播图
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Element from "element-ui";
//国际化引入
import Vue from "vue";
import { mapMutations } from "vuex";
import { lang } from "../../assets/languages/getLanguageType.js";
Vue.prototype.$lang = lang;

export default {
  activeName: "second",
  name: "index",
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props: ["userId"],
  data() {
    return {
      userIds: null,
      s1: null,
      s2: null,
      s3: null,
      s4: null,
      s5: null,
      sList: null,
      isMobileFlg: false, //設置課程分類用，手機版，下拉的顯示等
      arrowdownCss: true, //設置課程分類用，手機版，下拉的顯示等
      arrowdownIcon: true, //設置課程分類用，手機版，下拉的顯示等
      heightOut: 0, //設置課程分類用，手機版，下拉的顯示等
      heightIn: 0, //設置課程分類用，手機版，下拉的顯示等
      courseInfo: {},
      currentIndex1: -1,
      currentIndex2: -1,
      tagOne: null,
      tagTwo: null,
      loading: false,
      menuList: null,
      recommendCourse: {},
      itemList: [],
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: {
          delay: 10000,
          disableOnInteraction: false, // 手动切换之后继续自动轮播
        },
        loop: true,
      },
    };
  },
  created() {
    //监听getMenuHeight
    window.addEventListener("resize", this.getMenuHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getMenuHeight);
  },
  mounted() {
    //获取设备屏幕的高度
    // const h = document.body.clientHeight;
    // this.$refs.indexDiv.style.height = h + "px";
    setTimeout(() => {
      const that = this;
      if (that.$refs.heightOut != undefined) {
        that.heightOut = that.$refs.heightOut.offsetHeight;
        that.heightIn = that.$refs.heightIn.offsetHeight;
        // console.log(this.heightOut)
        // console.log(this.heightIn)
        if (that.heightOut < that.heightIn) {
          that.arrowdownIcon = true;
        } else {
          that.arrowdownIcon = false;
        }
      }
    }, 2000);

    this.userIds = window.sessionStorage.getItem("id");
    this.getMenuHeight();
    this.companyId = window.sessionStorage.getItem("companyId");

    //取得首页所有课程
    this.loading = true;
    this.$api
      .post("/home/getHomeCourseInfo", {
        languageType: this.$lang(),
      })
      .then((response) => {
        this.courseInfo = response.data;
        // console.log("首页的所有课程", this.courseInfo);
        this.recommendCourse = this.courseInfo.starCourse.courseList;
        this.menuList = this.courseInfo.starCourse.menuList;
        this.sList = this.courseInfo.frontList;
        if (this.sList != null) {
          for (var k = 0; k < this.sList.length; k++) {
            if (k == 0) {
              this.s1 = this.sList[k].imagePath;
            }
            if (k == 1) {
              this.s2 = this.sList[k].imagePath;
            }
            if (k == 2) {
              this.s3 = this.sList[k].imagePath;
            }
            if (k == 3) {
              this.s4 = this.sList[k].imagePath;
            }
            if (k == 4) {
              this.s5 = this.sList[k].imagePath;
            }
          }
        }
        this.loading = false;
      });

    if (this._isMobile()) {
      this.isMobileFlg = true; //手机端
      this.arrowdownIcon = false;
    } else {
      this.isMobileFlg = false; //pc端
    }
  },
  methods: {
    //移动端：滑动功能，增加css的方式。
    //PC端：显示下拉箭头
    getMenuHeight() {
      const that = this;
      if (that.$refs.heightOut != undefined) {
        that.heightOut = that.$refs.heightOut.offsetHeight;
        that.heightIn = that.$refs.heightIn.offsetHeight;
        // console.log(this.heightOut)
        // console.log(this.heightIn)
        if (that.heightOut < that.heightIn) {
          that.arrowdownIcon = true;
        } else {
          that.arrowdownIcon = false;
        }
      }
    },
    //作用：为primarymenu增加primarymenu-add
    cssedit() {
      this.arrowdownCss = !this.arrowdownCss;
    },

    //作用：判断终端设备
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },

    handleClick(el, a, b) {
      // console.log(el, a, b);
    },
    explore: function () {
      // 用 #explore 添加锚点
      let jump = document.querySelectorAll("#explore");
      let total = jump[0].offsetTop;
      let distance = document.getElementById("app").scrollTop;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 50;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 50;
        smoothUp();
      }

      function smoothDown() {
        if (distance < total) {
          distance += step;
          document.getElementById("app").scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          document.getElementById("app").scrollTop = total;
        }
      }

      function smoothUp() {
        if (distance > total) {
          distance -= step;
          document.getElementById("app").scrollTopp = distance;
          setTimeout(smoothUp, 10);
        } else {
          document.getElementById("app").scrollTop = total;
        }
      }
    },
    go_regist: function () {
      this.$emit("info", "regist");
    },
    goRouter: function (url, tagOneId) {
      if (tagOneId) {
        this.$router.push({
          path: url,
          query: {
            tagOne: tagOneId,
          },
        });
      } else {
        this.$router.push(url);
      }
    },
    begin_start: function () {
      // console.log(document.getElementById("2"));
      //this.$router.push("/home/personSet");
    },
    ...mapMutations("header", ["setHistory"]),
    go_course: function (item, collegeId) {
      this.userIds = window.sessionStorage.getItem("id");
      if (this.userIds == "" || this.userIds == null) {
        this.$alert(window.vm.$i18n.t("js.PleaseLogin"), "", {
          confirmButtonText: window.vm.$i18n.t("js.confirm"),
        });
        return;
      } else {
        window.sessionStorage.setItem("courseGOBackNum", 1);
        this.setHistory("/home");
        this.$router.push({
          name: "Aicourse",
          query: {
            buyCourseId: item.courseId,
            buyCollegeId: collegeId,
          },
        });
      }
    },

    secondMenuChange: function (index1, id) {
      if (this.tagTwo == id) {
        return;
      }
      this.tagTwo = id;
      let allFlag = 1;
      if (id === -1) {
        //如果二级分类为-1，那就把一级id传给后台
        this.tagTwo = this.courseInfo.courses[index1].id;
        allFlag = 1;
      } else {
        allFlag = 0;
      }
      this.tagOne = this.courseInfo.courses[index1].id;
      this.loading = true;
      this.companyId = window.sessionStorage.getItem("companyId");
      this.$api
        .post("/home/getHomeCourseInfoChild", {
          id: this.tagTwo,
          allFlag: allFlag,
          languageType: this.$lang(),
        })
        .then((response) => {
          // console.log(response.data.courseList)
          this.courseInfo.courses[index1].courseList = response.data.courseList;
          this.loading = false;
        });
    },
    mouseOverUp($event) {
      $event.currentTarget.className = "el-icon-arrow-up oaa";
    },
    mouseLeaveUp($event) {
      $event.currentTarget.className = "el-icon-arrow-up up_laa";
    },
    mouseOverDown($event) {
      $event.currentTarget.className = "el-icon-arrow-down oaa";
    },
    mouseLeaveDown($event) {
      $event.currentTarget.className = "el-icon-arrow-down down_laa";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  padding-top: 60px;
}

a {
  text-decoration: none;
  color: white;
  -webkit-tap-highlight-color: white;
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
.l {
  float: left;
}
.r {
  float: right;
}
.clear::after {
  content: ".";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
}
.container,
.bigCourse {
  width: 1200px;
  margin: 0 auto;
}

@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .container,
  .bigCourse {
    width: 1000px;
  }
}
@media screen and (min-width: 800px) and (max-width: 1000px) {
  .container,
  .bigCourse {
    width: 800px;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .container,
  .bigCourse {
    width: 600px;
  }
}
@media screen and (max-width: 600px) {
  .container,
  .bigCourse {
    width: 400px;
  }
}
.swiper-container {
  margin-bottom: 20px;
  position: relative;
  /* overflow: hidden;
    height: 450px; */
}
.swiper-container img {
  width: 100%;
}

.primarylists {
  padding-top: 10px;
}

.primarylists > ul > li {
  padding-bottom: 20px;
  width: 1210px;
  overflow: hidden;
}
.primarylists ul li .titles {
  height: 35px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  color: black;
  margin-bottom: 10px;
  display: flex;
  inline-size: max-content;
}

.secondlists {
  padding-left: 30px;
}
.secondlists > ul > li {
  padding-bottom: 10px;
  overflow: hidden;
}

.secondlists ul li .titles {
  height: 35px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  padding-left: 5px;

  color: black;
  margin-bottom: 5px;
  display: flex;
  inline-size: max-content;
}

.secondlists ul li .titles .title {
  font-size: 22px;
  text-decoration: underline;
  line-height: 35px;
  font-weight: bold;
}

.secondlists ul li img {
  height: auto;
  width: 100%;
  margin-top: 10px;
  overflow: hidden;
}

.secondlists ul li p {
  font-size: 14px;
  margin-top: 10px;
}

.thirdlists {
  padding-left: 30px;
}
.thirdlists > ul > li {
  padding-bottom: 10px;
  padding-left: 30px;
  overflow: hidden;
}

.thirdlists ul li .titles {
  height: 35px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  padding-left: 5px;
  color: black;
  margin-bottom: 5px;
  display: flex;
  inline-size: max-content;
}

.thirdlists ul li .titles .title {
  font-size: 22px;
  text-decoration: underline;
  line-height: 35px;
  font-weight: bold;
}

.thirdlists ul li img {
  height: auto;
  width: 100%;
  margin-top: 10px;
  overflow: hidden;
}

.thirdlists ul li p {
  font-size: 14px;
  margin-top: 10px;
}

.primarylists ul li .titles img {
  width: 32px;
  height: 32px;
  margin-top: 1px;
}
.primarylists ul li .titles .title {
  font-size: 24px;
  padding: 0 20px 0 10px;
  line-height: 35px;
  font-weight: bold;
}

.primarylists ul li .titles .more {
  font-size: 16px;
  line-height: 35px;
  cursor: pointer;
  padding-right: 20px;
}
.primarylists ul li .titles .more a {
  color: black;
}

.primarylists .secondlist {
  height: 100%;
  font-size: 16px;
}
.primarylists .secondlist ul li {
  float: left;
  padding: 3px 10px;
  cursor: pointer;
  margin-right: 16px;
  background: #666;
  border-radius: 15px;
  color: white;
}
.primarylists .secondlist ul li.choose {
  background: lightskyblue;
}

.primarylists .lessons ul {
  height: 350px;
  overflow: hidden;
  transform: translateX(5px);
}

.primarylists .lessons ul li {
  width: 190px;
  height: 170px;
  float: left;
  box-sizing: border-box;
  background: #333;
  background-clip: padding-box;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
}
.primarylists .lessons ul li:nth-of-type(1) {
  width: 390px;
  height: 350px;
}
.primarylists .lessons ul li:nth-of-type(1) .img {
  height: 200px;
}
.primarylists .lessons ul li .img {
  height: 100px;
  width: 100%;
  overflow: hidden;
}
.primarylists .lessons ul li .img img {
  width: 100%;
  transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -webkit-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
}
.primarylists .lessons .lessontitle {
  padding: 0px 10px;
  margin: 8px 0 3px;
  color: #f8f8f8;
  font-size: 15px;
  cursor: pointer;
  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.primarylists .lessons .lessontitle:hover {
  color: lightskyblue;
}
.primarylists .lessons .introduce {
  padding: 0 10px;
  color: #999;
  font-size: 12px;

  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.primarylists .lessons .islike {
  float: right;
  margin: 2px 10px 3px 0px;
  color: #f8f8f8;
  font-size: 10px;
  cursor: pointer;
  overflow: hidden;
}

.primarylists .lessons .islike span {
  float: right;
}

.primarylists .lessons ul li:nth-of-type(1) .lessontitle {
  font-size: 16px;
  padding: 15px 20px 0 20px;
  /* 2行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.primarylists .lessons ul li:nth-of-type(1) .introduce {
  font-size: 14px;
  line-height: 24px;
  padding: 10px 20px 0 20px;
  /* 3行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.footer {
  padding: 50px 0 30px 0;
  color: white;
  text-align: center;
  background: url(../../../static/images/bg/myCourseBackgroundFoot.jpg)
    no-repeat center bottom;
  background-size: cover;
}
.footer .line1 {
  font-size: 46px;
}
.footer .line2 {
  font-size: 14px;
  margin-bottom: 30px;
}
.footer .line3 {
  display: inline-block;
  padding: 5px 50px;
  border: 1px solid white;
  border-radius: 20px;
}
.footer .line3:hover {
  background: white;
  color: black;
  cursor: pointer;
}
.header {
  height: 60px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #121212;
  color: white;
  z-index: 10;
  opacity: 0.8;
}
.header ul li {
  float: left;
  margin-right: 30px;
}
.header .logo {
  padding-top: 12px;
  cursor: pointer;
}
.header .logo img {
  height: 36px;
}
.header ul li div {
  height: 12px;
  font-size: 12px;
  position: relative;
}
.header ul li:hover div {
  color: #999;
}
.header ul li div span {
  height: 16px;
  width: 16px;
  line-height: 16px;
  text-align: center;
  background: red;
  color: white;
  display: block;
  border-radius: 50%;
  position: absolute;
  bottom: -8px;
  right: -18px;
}
.header ul li p {
  padding-top: 5px;
  font-size: 20px;
  text-align: center;
  color: #409eff;
}

.header .right {
  padding-top: 10px;
}
.header .right .user > div {
  margin-right: 10px;
}
.header .right .user .photo {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
}
.header .right .user .photo img {
  width: 100%;
}
.header .right .user .name,
.header .right .user .logout {
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.header .right .user .name:hover,
.header .right .user .logout:hover {
  color: #999;
}

.header .right .search {
  margin: 0 20px;
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.header .right .search:hover {
  color: #999;
}
.header .right .flag {
  height: 40px;
  width: 60px;
  cursor: pointer;
  overflow: hidden;
  border-radius: 5px;
}
.header .right .flag img {
  width: 100%;
}
.swiper_bottom_shade {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
  height: 200px;
  width: 100%;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(224, 224, 219, 0)),
    to(#fff)
  );
  background: -webkit-linear-gradient(top, rgba(224, 224, 219, 0), #fff 100%);
  background: linear-gradient(180deg, rgba(224, 224, 219, 0), #fff 100%);
}
.bigCourse {
  position: relative;
}
.bigCourse ul {
  /*background-color: rgba(255,255,255,0.7);*/
  /*border-radius: 10px;*/
  /*padding: 30px 2% 0;*/
  width: 98%;
  margin: 0 1%;
  /*position: absolute;*/
  /*bottom: 10px;*/
  /*z-index: 9;*/
}

.bigCourse li a {
  font-size: 14px;
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  padding: 5px 15px;
  border-radius: 5px;
  margin-right: 20px;
  float: left;
  margin-bottom: 10px;
}
.bigCourse li a:hover {
  background-image: -webkit-linear-gradient(315deg, #00d3ff 0%, #02adff 100%);
  background-image: linear-gradient(135deg, #00d3ff 0%, #02adff 100%);
}
.showAllCourse {
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}
.showAllCourse img {
  width: 19px;
}
/* .showAllCourse i{*/
/*  font-size: 20px;*/
/*   font-weight: bold;*/
/*   color: #666;*/
/*}*/
/*.showAllCourse i :hover{*/
/*  color: #02ADFF;*/
/*}*/
.primarymenu-add {
  height: 39px;
  overflow: hidden;
}
.boxout {
}
.boxout .boxin {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.boxout .boxin li.SchoolBusiness_menu_li {
  box-sizing: border-box;
}
::-webkit-scrollbar {
  display: none;
}

.el-tabs >>> .el-tabs__active-bar {
  height: 30px;
  background-color: #02adff;
  border-radius: 25px;
  padding: 0 20px;
  margin-left: -20px;
  margin-bottom: 5px;
}
.el-tabs >>> .el-tabs__item {
  z-index: 2;
}
.el-tabs >>> .el-tabs__nav-wrap:after {
  height: 0px;
  background-color: none;
}
.el-tabs >>> .el-tabs__nav-scroll {
  padding: 0 20px;
}
.el-tabs >>> .el-tabs__item.is-active {
  color: #fff;
}
.el-tabs >>> .toolbar {
  padding-top: 20px;
}
.el-tabs >>> .el-pager {
  margin: 0 10px;
}
.vaa :hover {
  transform: scale(1.05, 1.05);
  cursor: pointer;
}
.down_laa {
  -webkit-text-stroke-width: 2px;
  color: #999;
}
.up_laa {
  -webkit-text-stroke-width: 2px;
  color: #00d3ff;
}
.oaa {
  -webkit-text-stroke-width: 2px;
  color: #ffb821;
}
.target-fix {
  position: relative;
  top: -60px;
  display: block;
  height: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/index/manual_ja.vue